<template>
<div>
  <b-card>
    <b-row>
      <b-col>
        <div>
          <b-form-group label="Usuario">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" placeholder="Usuario" v-model="user" disabled></b-form-input>
          </b-input-group>
          </b-form-group>
        </div>

        <div>
          <b-form-group label="Saldo">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" placeholder="Saldo" v-model="saldoAux" disabled></b-form-input>
          </b-input-group>
          </b-form-group>
        </div>

        <div>
          <b-form-group label="Descargar">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="number" placeholder="Descargar" v-model="recarga"></b-form-input>
          </b-input-group>
          </b-form-group>
        </div>

        <br>
        <div>
        <b-button align='center' variant='outline-success' @click='save'>
            Guardar
        </b-button>
        </div>
      </b-col>
      <b-col align='center'>
         <qr-code :text='code' :size=250 error-level='L'></qr-code>
         <h3>Codigo: {{code}} </h3>
      </b-col>
    </b-row>
  </b-card>
  <!-- <qrcode-reader @decode='onDecode'></qrcode-reader>
  <carnetsForm :typeEndPoint=''adminCarnetsShow'' :dataParams='this.$route.params' />-->
</div>
</template>
<script>
import carnetsForm from '@/components/modules/admin/carnets/form'
import inputText from '@/views/base/form/inputText'
import inputNumber from '@/views/base/form/inputNumber'
import inputSelect from '@/views/base/form/inputSelect'
import {currencyFormat} from '@/api' 

export default {
  name: 'CarnetsFormEdit',
  components: {
    carnetsForm,
    inputText,
    inputNumber,
    inputSelect
  },
  data: function () {
    return {
      qr: '',
      options: [
        {
          'value': null,
          'text': 'Seleccione una Opcion',
          'selected': true
        },
        {
          'value': 1,
          'text': 'Activo'
        },
        {
          'value': 0,
          'text': 'Inactivo'
        }
      ],
      name: {
        'type': 'text-input',
        'name': 'name_user_primary',
        'label': 'Usuario',
        'placeholder': 'Seleccione usuario',
        'data': 'Juan'
      },
      user: '',
      saldo: '',
      saldoAux:'',
      recarga: 0,
      code: '',
      active: 1
    }
  },
  created () {
    this.search()
  },
  computed: {
    recargaAux:{
      get(){
        return this.recarga
      },
      set(newval){
        if (! /^[0-9]+$/.test(newval)) {
          newval.substring(0, newval.length-1);
        }
        
      }
    }
  },
  methods: {
    save () {
      let data = {
        'id': this.$route.params.id,
        'id_user_primary': this.$store.getters.adminCarnets.formData.id_user_primary,
        'saldo':this.saldo,
        'recarga':(this.recarga * -1),
        'code':this.code,
        'active': this.active
      }
      let json = JSON.stringify(data)
      this.$store.dispatch('adminCarnetsUpdate', json).then(response => {
        this.$root.showInfoDialog('Mensaje Informativo','Nuevo saldo disponible '+currencyFormat((Number(this.saldo)-Number(this.recarga))),'Aceptar')
        this.recarga = 0
        this.$router.push({
          path: '/admin/validatecarnet'
        })
      })
    },
    update_code(){
      let json = JSON.stringify(this.$route.params)
      this.$store.dispatch('adminCarnetsUpdateCode',json).then(response =>{
        this.$root.showInfoDialog('Mensaje Informativo','Codigo actualizado','Aceptar')
        this.adminCarnetsShow(json)
      }).catch(error => {

      })
    },
    search () {
      let json = JSON.stringify(this.$route.params)
      this.adminCarnetsShow(json)
    },
    adminCarnetsShow(json){
      
      console.log('format',)
      this.$store.dispatch('adminCarnetsShow', json).then(response => {
        this.user = this.$store.getters.adminCarnets.formData.name_user_primary
        this.saldoAux = currencyFormat(this.$store.getters.adminCarnets.formData.saldo)
        this.saldo = this.$store.getters.adminCarnets.formData.saldo
        this.active = this.$store.getters.adminCarnets.formData.active
        this.code = this.$store.getters.adminCarnets.formData.code
      }).catch(error => {
        console.log(error)
      })
    },
    format(value) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(10000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/descarga.vue